export default "__VITE_ASSET___IIEfaDl__"